<template>
  <q-page-container>
    <q-page>
      <div class="header">
        <section
          class="q-pt-lg section-header-description flex row justify-between"
        >
          <label>Meu histórico</label>
        </section>
        <q-separator color="#C6C6C6" size="2px" spaced="md" />
        <section class="col-12 row section-search q-pt-sm">
          <div class="col-12 row">
            <div class="col-12 row">
              <q-input
                class="col-12"
                bg-color="white"
                v-model="search"
                type="search"
                outlined
                color="red-9"
                placeholder="Pesquisar"
                dense="dense"
                @keyup="filterContingecyById(search)"
              >
                <template v-slot:append>
                  <q-icon name="search" />
                </template>
              </q-input>
            </div>
          </div>
        </section>
      </div>
      <div class="content-cards-histories">
        <section class="col-12 row section-cards-histories">
          <div class="col-12 row">
            <div
              class="col-12 row flex justify-center"
              v-for="(item, index) in contigencyHistoryFilter"
              :key="index"
            >
              <CardContingecyHistory :data="item" />
            </div>
          </div>
        </section>
      </div>
    </q-page>
  </q-page-container>

  <q-page-sticky position="bottom-right" :offset="[18, 18]">
    <router-link :to="{ name: 'config-contingency' }">
      <q-btn fab icon="add" color="red-9" />
    </router-link>
  </q-page-sticky>
</template>

<script>
import CardContingecyHistory from "@/components/contingency/CardContingecyHistory.vue";

//-----VUEJS
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
//-----QUASAR
import { useQuasar } from "quasar";
//-----SERVICES
import ContingencyServices from "@/services/ContingencyServices";
//-----UTILS
import formatDate from "@/utils/dateFormat/dateFormate";
import { disableContigency } from "@/utils/ResquestOsForms/createContigencyAction.js";

export default {
  name: "HistoryContingency",
  components: {
    CardContingecyHistory,
  },
  setup() {
    //----CONSTANTS
    const contigencyHistory = ref([]);
    const contigencyHistoryFilter = ref([]);

    const $q = useQuasar();
    const store = useStore();
    const usuerLogged = store.state.userdata;
    //----VARIABLES
    let btnLoading = ref(false);
    let contingencyServices = new ContingencyServices();
    let search = ref("");

    async function getHistoricalContingency() {
      await contingencyServices
        .getHistoricalContingency()
        .then((response) => {
          console.log(response);
          contigencyHistory.value = response;
          contigencyHistoryFilter.value = response;
        })
        .catch((error) => {
          btnLoading.value = false;
          $q.notify({
            message: error.toString(),
            color: "red-9",
            position: "top",
          });
        });
    }

    function filterContingecyById(text) {
      if (text == "") {
        contigencyHistoryFilter.value = contigencyHistory.value;
        return;
      }

      contigencyHistoryFilter.value = contigencyHistory.value.filter((item) => {
        if (item.chamado != null) {
          return item.chamado
            .toLowerCase()
            .toString()
            .includes(text.toLowerCase().toString());
        }
      });
    }

    onMounted(() => {
      getHistoricalContingency();
    });

    return {
      //----VARIABLES
      btnLoading,
      contigencyHistory,
      usuerLogged,
      contigencyHistoryFilter,
      search,

      //FUNCTIONS
      filterContingecyById,
    };
  },
};
</script>

<style lang="scss" scoped>
a {
  text-decoration: none;
}

.header {
  padding: 2% 4%;

  .section-header-description {
    padding: 10% 0% 0% 1%;

    label {
      font-family: Roboto;
      font-style: normal;
      font-weight: bold;
      font-size: 16px;
      line-height: 19px;
      color: #999999;
    }
  }

  .section-search {
    .icon-tune {
      color: #999999;
    }
  }
}

.content-cards-histories {
  padding: 2% 5%;
}
</style>
